import { useQuery } from 'react-query';

import { axios } from 'lib/axios';
import { NOTIFICATIONS_REFRESH_INTERVAL } from './getNotifications';

export const getUnreadCount = () => {
  return axios.get('/api/notifications/unread_count');
};

export const useUnreadNotificationsCount = (queryOptions = {}) => {
  return useQuery(['notifications', 'unread-count'], getUnreadCount, {
    select: ({ data }) => data.count ?? 0,
    useErrorBoundary: false,
    refetchInterval: NOTIFICATIONS_REFRESH_INTERVAL,
    refetchOnWindowFocus: true,
    ...queryOptions,
  });
};
